import {
  ISubscriptionActiveFormFieldsStructured,
  ISubscriptionActiveFormFieldsStructuredRequirePesel,
  ISubscriptionFormFieldsStructured,
  RequirePeselValue,
  SubscriptionFormField,
} from "web/types/Subscription";

const isActiveFormField = (
  formField: SubscriptionFormField
): formField is ISubscriptionActiveFormFieldsStructured => {
  return (
    (formField as ISubscriptionActiveFormFieldsStructured).id !== undefined
  );
};

export default (fieldsStructured: SubscriptionFormField[]) => {
  const values = fieldsStructured.reduce<
    Record<string, string | RequirePeselValue | boolean>
  >((finalValues, currentField) => {
    const newValues = { ...finalValues };
    if (isActiveFormField(currentField)) {
      newValues[currentField.id] = getValueActiveFormField(currentField);
    } else {
      newValues[currentField.type] = getValueSimpleFormField(currentField);
    }

    return newValues;
  }, {});

  return values;
};

const isRequirePesel = (
  field: ISubscriptionActiveFormFieldsStructured
): field is ISubscriptionActiveFormFieldsStructuredRequirePesel =>
  (field as ISubscriptionActiveFormFieldsStructuredRequirePesel).options !==
  undefined;

const getValueActiveFormField = (
  field: ISubscriptionActiveFormFieldsStructured
) => {
  if (isRequirePesel(field)) {
    const requirePeselValues: RequirePeselValue = {
      pesel: field.options[0].value,
      birthDate: field.options[1].value,
      babyOrForeigner: field.options[2].value,
    };

    return requirePeselValues;
  }

  return field.value;
};
const getValueSimpleFormField = (field: ISubscriptionFormFieldsStructured) =>
  field.value;
